import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;  
  .ant-menu-item {
    background-color: #ffffff !important;
    &:hover {
      background-color: rgba(14, 19, 24, 0.07) !important;
      color: #0e1318;
    }
  }
`;

export const MenuItem = styled.div`
background-color: hsla(0,0%,100%,0.07);
  padding: 14px;
  transition: background-color 0.2s ease-in-out;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 4px;
  margin-bottom: 10px
  width:320px;
  text-align:center;
  cursor:pointer;
  &:hover{
    background-color: hsla(0,0%,100%,0.15);
  }
`;
